import styled from 'styled-components';
import { zIndex, fontWeights } from 'app/styles/variables';
import Checkbox from 'app/shared/components/Checkbox/Checkbox';
import { Info } from '@heycar-uikit/icons';
import { Button } from 'app/shared/components/Button/Button';

export const SettingCheckBoxSt = styled(Checkbox)`
  margin: 0 1rem 0 0;
  cursor: pointer;
`;

export const MoreInfoSwitchSt = styled(Button).attrs({
  variant: 'link',
  size: 'large',
})`
  margin-top: 0.5rem;
`;

export const MoreInfoSt = styled.div<{ isCollapsed: boolean }>`
  display: ${props => (props.isCollapsed ? 'none' : 'block')};
`;

export const MoreInfoItemSt = styled.div`
  position: relative;
`;

export const MoreInfoTitleSt = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  font-weight: ${fontWeights.bold};
  height: 2rem;

  & > i {
    position: relative;
    top: 5px;
    left: 1rem;
    font-size: 1.5rem;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.neutral600};
  }
  color: ${({ theme }) => theme.colors.primary};
`;

export const MoreInfoBubbleSt = styled.div<{ isOpen: boolean }>`
  position: absolute;
  z-index: ${zIndex.overlay + 100};
  top: -1.25rem;
  left: -1.5rem;
  display: ${props => (props.isOpen ? 'block' : 'none')};
  width: 23.5rem;
  padding: 1.5rem 1.5rem 2rem 1.5rem;

  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 0.125rem 1rem 0 rgba(0, 0, 0, 0.13);
  line-height: 1.5;

  & > strong {
    display: block;
    margin-bottom: 1rem;
  }

  & > i {
    position: absolute;
    top: 1.5rem;
    right: 1.5rem;
    font-size: 1.25rem;
    cursor: pointer;
  }
`;

export const SettingsHeaderSt = styled.div<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  margin: 4rem 0 1.5rem -0.5rem;
  color: ${({ disabled, theme }) =>
    disabled ? theme.colors.neutral600 : theme.colors.neutral800};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'default')};
`;

export const InfoSt = styled(Info)`
  cursor: pointer;
  margin-left: 0.5rem;
`;

export const CheckboxLabelSt = styled.h2`
  margin: 0;
`;
